module.exports = __webpack_public_path__ + "img/ic_nat_unpay.c6a35253.png";